import React, { useEffect, useState, Fragment } from 'react';
import { Pagination, PageHeader, paginate } from '../../../Common';
import { TableContent } from '../../Common/Table/tableContent';
import { Fields, validateProperty, validate, Card } from "../../Common";
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import services from '../services';
import MenuItem from '@material-ui/core/MenuItem';
import $ from 'jquery';
import { advancedRequestSchemaObject } from '../advancedRequestSchema';
import { LoadingSpinerComponent } from '../../../Common/loader'
import { trackPromise } from 'react-promise-tracker'
import Joi from '@hapi/joi'
import FormHelperText from '@material-ui/core/FormHelperText';
import authService from '../../Common/services';
import tokenService from '../../../Common/tokenDecoder';
import Modal from "@material-ui/core/Modal";
import Fade from "@material-ui/core/Fade";
import Backdrop from "@material-ui/core/Backdrop";
import { makeStyles } from "@material-ui/core/styles";
import { TextField } from "@material-ui/core";

const screenCode = 'ADVANCEDREQUEST'

const useStyles = makeStyles((theme) => ({
    modal: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: theme.spacing(4, 6, 9),
        borderRadius: 10,
        width: 600,
    },
    root: {
        "& > *": {
            margin: theme.spacing(5),
        },
    },
    remark: {
        width: 500,
    },
}));

export function AdvancedRequestListing(props) {
    const [advancedRequest, setAdvancedRequest] = useState([]);
    const classes = useStyles();
    const [customerSearchData, setCustomerSearchData] = useState({
        groupID: '0',
        operationEntityID: '0',
        collectionPointID: '0',
        fromDate: '',
        toDate: '',
        statusID: '1'
    });
    const [isTableHide, setIsTableHide] = useState(true);
    const [errors, setErrors] = useState({});
    const [operationEntities, setOperationEntities] = useState([]);
    const [groups, setGroups] = useState();
    const [collectionPoints, setCollectionPoints] = useState([]);
    const [permissionList, setPermissions] = useState({
        isAddEditEnabled: false,
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });
    const [open, setOpen] = useState(false);
    const contentRowNames = ["createdDate", "collectionPointName", "registrationNumber", "firstName", "requestedAmount"]

    const schema = Joi.object(advancedRequestSchemaObject).options({ allowUnknown: true });

    useEffect(() => {
        getPermissions();
    }, []);

    useEffect(() => {
        trackPromise(
            getOperationEntities(),
            handleSearch()
        )
    }, [customerSearchData.groupID])

    useEffect(() => {
        trackPromise(
            getCollectionPoints()
        )
    }, [customerSearchData.operationEntityID])

    async function getPermissions() {

        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWADVANCEDREQUEST');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }

        var isAddEditEnabled = permissions.find(p => p.permissionCode == 'ADDEDITADVANCEDREQUEST');
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');

        setPermissions({
            ...permissionList,
            isAddEditEnabled: isAddEditEnabled !== undefined,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined
        });

        var token = tokenService.getUserDetailsFromToken();
        setCustomerSearchData({
            ...customerSearchData,
            groupID: token.groupID,
            operationEntityID: token.operationEntityID
        });

        getAllGroups();
    }

    async function getOperationEntities() {
        var data = await services.getEstatesByGroupID(customerSearchData.groupID);
        setOperationEntities(data)
    }
    async function getAllGroups() {
        const result = await services.getGroups()
        setGroups(result)
    }
    async function getCollectionPoints() {
        const result = await services.getCollectionPointsByOperationentityGroupID(customerSearchData.groupID, customerSearchData.operationEntityID)
        setCollectionPoints(result)
    }

    function generateDropDownMenu(data) {
        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>)
            }
        }
        return items
    }
    function destroyDataTable() {
        setIsTableHide(true);
        $('#example').DataTable().destroy();

    }

    function createDataTable() {
        $('#example').DataTable();
        setIsTableHide(false);
    }

    function handleClick(item) {
         props.history.push({
             pathname: 'advancedRequest/addEdit',
             data: item,
             edit: true
         })
    }

    async function handleSearch(e) {
        destroyDataTable();
        const errorMessages = validate(schema, customerSearchData);
        errorMessages !== null ? setErrors(errorMessages) : setErrors({});
        if (errorMessages) return;

        const result = await services.getAllAdvancedRequestByFilter(customerSearchData.operationEntityID,
            customerSearchData.collectionPointID, customerSearchData.fromDate, customerSearchData.toDate, customerSearchData.statusID);
        result.forEach(x => {
            x.createdDate = x.createdDate.split('T')[0];
            x.requestedAmount = x.requestedAmount.toFixed(2);
            x.approvedAmount = x.approvedAmount.toFixed(2);
            x.statusID =  x.statusID === 1 ? "new" : x.statusID === 2 ? "Approved" : (x.statusID === 3 ? "Rejected" : "Delivered");
        })
        setAdvancedRequest(result);
        createDataTable();

    }

    function handleChange(e) {
        e.preventDefault();

        const target = e.target;
        const value = target.value;

        const error = { ...errors };
        const errorMessage = validateProperty(target, advancedRequestSchemaObject);
        errorMessage ? error[target.name] = errorMessage : delete error[target.name];

        setCustomerSearchData({
            ...customerSearchData,
            [e.target.name]: value
        });

        setErrors(error);
    }

    

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <div className="card-body">
                            <div className="row">
                                <PageHeader
                                    title="Advanced Request "
                                />
                            </div>
                            <hr />

                            <form>
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="groupID"
                                            id="groupID"
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            name="groupID"
                                            value={customerSearchData.groupID}
                                            onChange={(e) => handleChange(e)}>
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && <FormHelperText error>{errors["groupID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="operationEntityID">Operation Entity *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="operationEntityID"
                                            id="operationEntityID"
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            name="operationEntityID"
                                            value={customerSearchData.operationEntityID}
                                            onChange={(e) => handleChange(e)}>
                                            <MenuItem value="0">--Select Operation Entity--</MenuItem>
                                            {generateDropDownMenu(operationEntities)}
                                        </Select>
                                        {errors["operationEntityID"] && <FormHelperText error>{errors["operationEntityID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md">
                                        <InputLabel shrink id="collectionPointID">Collection Point</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="collectionPointID"
                                            id="collectionPointID"
                                            name="collectionPointID"
                                            value={customerSearchData.collectionPointID}
                                            onChange={(e) => handleChange(e)}>
                                            <MenuItem value="0">--Select Collection Point--</MenuItem>
                                            {generateDropDownMenu(collectionPoints)}
                                        </Select>
                                        {errors["collectionPointID"] && <FormHelperText error>{errors["collectionPointID"]}</FormHelperText>}
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <div className="col-md">
                                        <InputLabel shrink id="fromDate">From Date *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="fromDate"
                                            name="fromDate"
                                            type="date"
                                            value={customerSearchData.fromDate}
                                            onInput={(e) => handleChange(e)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                    </div>
                                    <div className="col-md">
                                        <InputLabel shrink id="toDate">To Date *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="toDate"
                                            name="toDate"
                                            value={customerSearchData.toDate}
                                            type="date"
                                            onInput={(e) => handleChange(e)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                    </div>
                                    <div className="col-md">
                                        <TextField select fullWidth
                                            label="Status "
                                            id="statusID"
                                            name="statusID"
                                            value={customerSearchData.statusID}
                                            type="text"
                                            onChange={(e) => handleChange(e)}>
                                            <option value="1">New</option>
                                            <option value="2">Approved</option>
                                            <option value="3">Rejected</option>
                                            <option value="4">Delivered</option>
                                        </TextField>
                                    </div>
                                </div>
                                <div className="card-footer">
                                    <input
                                        type="button"
                                        onClick={(e) => handleSearch(e)}
                                        className="btn btn-primary"
                                        value="Search"
                                    />
                                </div>
                            </form>
                            <div hidden={isTableHide} className="table-responsive row-top-gap">
                                <table id="example" className="display dataTable no-footer" >
                                    <thead>
                                        <tr>
                                            <th>Date</th>
                                            <th>Collection Point</th>
                                            <th>Reg No</th>
                                            <th>Customer Name</th>
                                            <th>Requested Amount</th>
                                            <th>Actions</th> 
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <TableContent
                                            data={advancedRequest}
                                            contentRowNames={contentRowNames}
                                            handleClick={handleClick}
                                            hasEdit={permissionList.isAddEditEnabled}
                                        />
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}